// Indian numeric formatting helpers
export const fmtINR = (v, opts = {}) => {
  if (v === null || v === undefined || isNaN(v)) return "₹0";
  const n = Number(v);
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (opts.short) {
    if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(opts.decimals ?? 2)} Cr`;
    if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(opts.decimals ?? 2)} L`;
    if (abs >= 1e3) return `${sign}₹${(abs / 1e3).toFixed(opts.decimals ?? 1)} K`;
    return `${sign}₹${abs.toFixed(0)}`;
  }
  if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(2)} L`;
  return `${sign}₹${abs.toLocaleString("en-IN")}`;
};

export const fmtNum = (v) => {
  if (v === null || v === undefined) return "0";
  return Number(v).toLocaleString("en-IN");
};

export const fmtPct = (v, decimals = 1) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return `${Number(v).toFixed(decimals)}%`;
};

export const fmtDelta = (v) => {
  if (v === null || v === undefined) return null;
  const sign = v > 0 ? "+" : "";
  return `${sign}${Number(v).toFixed(1)}%`;
};
